import {Location} from '@gakki/api/check-in';
import LocationName from './location-name';
import LocationAddress from './location-address';
import IPAddress from './ip-address';
import ControlPanel from './control-panel';

type LocationCardProps = {
  onRemove: () => void;
  onEdit: () => void;
  locationInfo?: Location;
};

function LocationCard(props: LocationCardProps) {
  const {locationInfo, onEdit, onRemove} = props;
  return (
    <div className={'w-[435px] border border-[#d5dadd]'}>
      <LocationName locationName={locationInfo?.locationName || ''} />
      <LocationAddress
        locationAddress={{
          address: locationInfo?.address,
          longitude: locationInfo?.location?.longitude,
          latitude: locationInfo?.location?.latitude,
        }}
      />
      <IPAddress ips={locationInfo?.ipAddresses || []} />
      <ControlPanel onEdit={onEdit} onRemove={onRemove} />
    </div>
  );
}

export default LocationCard;
